<template>
    <button @click="handleClick" :class="disabled ? 'disabled' : ''">
        {{ text }}
        <i></i>
    </button>
</template>
<script>
export default {
    props: {
        text: {},
        to: {},
        href: {},
        type: {},
        disabled: {},
    },
    methods: {
        handleClick() {
            if (this.to) {
                this.$router.push(this.to);
            }
            if (this.href) {
                window.open(this.href, '_blank');
            }
        },
    },
};
</script>
<style lang="scss" scoped>
button {
    border: 1px solid var(--orange);
    color: var(--orange);
    background-color: transparent;
    height: 40px;
    padding: 0 24px;
    font-family: 'Pretendard', sans-serif;
    font-size: 16px;
    font-weight: 400;
    cursor: pointer;

    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;

    &.disabled {
        opacity: 0.5;
        filter: grayscale(1);
        background: #eee;
        cursor: not-allowed;
    }

    i {
        display: inline-block;
        width: 7px;
        height: 11px;
        background-position: center;
        background-size: auto;
        background-repeat: no-repeat;
        background-image: url(@/assets/ic_arrow_orange.png);
    }

    &:hover {
        color: #fff;
        background-color: var(--orange);
        i {
            color: #fff;
            background-image: url(@/assets/ic_arrow_orange-w.png);
        }
    }
}
</style>
